import React from "react";
import { Card, Col } from "react-bootstrap"; 
import { FaCircle, FaSquare } from "react-icons/fa";
import { BiSolidUpArrow } from "react-icons/bi";
import "../audit_style.css";

interface Issue {
  name: string;
  value: number;
}

interface IssueSidebarProps {
  selectTab: string;
  activeSide: string | null;
  criticalCollected: Issue[];
  warningCollected: Issue[];
  noticesCollected: Issue[];
  passedCollected: Issue[];
  setSelectTab: (tab: string) => void;
  setActiveSide: (side: string | null) => void;
}

export const IssueSidebar: React.FC<IssueSidebarProps> = ({
  selectTab,
  activeSide,
  criticalCollected,
  warningCollected,
  noticesCollected,
  passedCollected,
  setSelectTab,
  setActiveSide,
}) => {
  const renderIssueList = (
    list: Issue[],
    prefix: string,
    color: string,
    Icon: React.ComponentType
  ) =>
    list.map((a, i) => {
      if (a.value === 0 && selectTab === "all") return null;
      return (
        <div
          key={i}
          style={{
            display: "flex",
            padding: "5px 8px",
            marginBottom: "5px",
            cursor: "pointer",
          }}
          className={`sideLeftMenu ${activeSide === prefix + i ? "sideLeftMenuActive" : ""}`}
          onClick={() => setActiveSide(prefix + i)}
        >
          <div className="nameClass">{a.name}</div>
          <div
            style={{
              marginLeft: "auto",
              fontWeight: 500,
              color: a.value > 0 ? color : "",
            }}
          >
            {a.value}
          </div>
        </div>
      );
    });

  return (
    <Col lg={3}>
      <Card
        className="p-4 mt-3"
        style={{
          maxWidth: "100%",
          boxShadow: "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
          maxHeight: "538px",
          overflow: "hidden",
        }}
      >
        <div  style={{ maxHeight: "520px", overflowY: "auto", paddingRight: "5px" }}>
          {selectTab === "all" ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "0.5rem",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ marginRight: "5px", color: "#327aee", marginTop: "-5px" }}>
                  <FaSquare />
                </div>
                <div>All Issue</div>
              </div>
            </div>
          ) : selectTab === "warnings" ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "0.5rem",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ marginRight: "5px", color: "#ffc107", marginTop: "-5px" }}>
                  <FaSquare />
                </div>
                <div>Warnings</div>
              </div>
            </div>
          ) : selectTab === "criticals" ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "0.5rem",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ marginRight: "5px", color: "#dc3545", marginTop: "-5px" }}>
                  <BiSolidUpArrow />
                </div>
                <div>Criticals</div>
              </div>
            </div>
          ) : selectTab === "notices" ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "0.5rem",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ marginRight: "5px", color: "#6c757d", marginTop: "-5px" }}>
                  <FaCircle />
                </div>
                <div>Notices</div>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "0.5rem",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ marginRight: "5px", color: "#198754", marginTop: "-5px" }}>
                  <FaCircle />
                </div>
                <div>Passed</div>
              </div>
            </div>
          )}
          <hr />
          {selectTab === "all" && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "0.5rem",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ marginRight: "5px", color: "#dc3545", marginTop: "-5px" }}>
                    <BiSolidUpArrow />
                  </div>
                  <div>Criticals</div>
                </div>
              </div>
              {renderIssueList(criticalCollected, "c", "#dc3545", BiSolidUpArrow)}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "0.5rem",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ marginRight: "5px", color: "#ffc107", marginTop: "-5px" }}>
                    <FaSquare />
                  </div>
                  <div>Warnings</div>
                </div>
              </div>
              {renderIssueList(warningCollected, "w", "#ffc107", FaSquare)}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "0.5rem",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ marginRight: "5px", color: "#6c757d", marginTop: "-5px" }}>
                    <FaCircle />
                  </div>
                  <div>Notices</div>
                </div>
              </div>
              {renderIssueList(noticesCollected, "n", "#6c757d", FaCircle)}
            </>
          )}
          {selectTab === "criticals" &&
            renderIssueList(criticalCollected, "c", "#dc3545", BiSolidUpArrow)}
          {selectTab === "warnings" &&
            renderIssueList(warningCollected, "w", "#ffc107", FaSquare)}
          {selectTab === "notices" &&
            renderIssueList(noticesCollected, "n", "#6c757d", FaCircle)}
          {selectTab === "passed" &&
            renderIssueList(passedCollected, "p", "#198754", FaCircle)}
        </div>
      </Card>
    </Col>
  );
};